<form *ngIf="block && form" [formGroup]="form">
  <pl-feedback
    #plFeedback
    [formControlName]="FormControlName.feedback"
    [isDisabled]="isDisabled"
    [isFormSubmitted]="courseContentService.isMainFormSubmitted()"
    [labelFeedbackText]="block.data.label_text"
    [placeholderFeedbackText]="block.data.placeholder_text"
    [title]="block.data.label_stars"
  />
</form>
